import $ from 'jquery';
window.jQuery = $;
import slick from 'slick-carousel';

$(window).on('load', function () {
  const $heroSlider = $('.hero-slider');
  let customTiming = false;
  let firstSlideIndex = 0;

  // Pause autoplay on load to manually control the first slide delay
  $heroSlider.slick({
    rows: 0,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    arrows: false,
    speed: 500,
    autoplay: false, // ← we'll start this manually after 8s
    autoplaySpeed: 4000,
    pauseOnFocus: false,
    pauseOnHover: false,
    pauseOnDotsHover: false,
    touchMove: false,
    swipe: false,
    touchThreshold: false,
    draggable: false,
    infinite: true
  });

  // Rewind videos before slide change
  $heroSlider.on('beforeChange', function () {
    $('video').each(function () {
      this.currentTime = 0;
    });
  });

  // Delay the first autoplay manually on load
  setTimeout(function () {
    $heroSlider.slick('slickPlay');
  }, 6000); // Initial 6s delay before first change

  // Identify and pause only on original .first slide
  $heroSlider.on('afterChange', function (event, slick, currentSlide) {
    // Get the current real slide DOM element
    const $current = $(slick.$slides.get(currentSlide));

    // Check if it is the real first slide (not a clone)
    const isFirstRealSlide =
      $current.hasClass('first') && $current.data('slick-index') === 0;

    if (isFirstRealSlide && !customTiming) {
      customTiming = true;
      $heroSlider.slick('slickPause');

      setTimeout(function () {
        $heroSlider.slick('slickPlay');
        customTiming = false;
      }, 6000); // 6 seconds for the real first slide
    }
  });

  // Init quote slider
  $('.quote-slider').slick({
    rows: 0,
    dots: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    speed: 500,
    autoplaySpeed: 5000,
    autoplay: true,
  });
});


